/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipping_Fee_DomesticInputs */

const en_shipping_fee_domestic = /** @type {(inputs: Shipping_Fee_DomesticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domestic`)
};

const es_shipping_fee_domestic = /** @type {(inputs: Shipping_Fee_DomesticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nacional`)
};

const fr_shipping_fee_domestic = /** @type {(inputs: Shipping_Fee_DomesticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`National`)
};

const de_shipping_fee_domestic = /** @type {(inputs: Shipping_Fee_DomesticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inland`)
};

const id_shipping_fee_domestic = /** @type {(inputs: Shipping_Fee_DomesticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domestik`)
};

/** @type {(inputs: Shipping_Fee_DomesticInputs) => LocalizedString} */
const ja_shipping_fee_domestic = en_shipping_fee_domestic;

/** @type {(inputs: Shipping_Fee_DomesticInputs) => LocalizedString} */
const zh_shipping_fee_domestic = en_shipping_fee_domestic;

/** @type {(inputs: Shipping_Fee_DomesticInputs) => LocalizedString} */
const ar_shipping_fee_domestic = en_shipping_fee_domestic;

/** @type {(inputs: Shipping_Fee_DomesticInputs) => LocalizedString} */
const it_shipping_fee_domestic = en_shipping_fee_domestic;

/** @type {(inputs: Shipping_Fee_DomesticInputs) => LocalizedString} */
const ru_shipping_fee_domestic = en_shipping_fee_domestic;

/** @type {(inputs: Shipping_Fee_DomesticInputs) => LocalizedString} */
const pt_shipping_fee_domestic = en_shipping_fee_domestic;

/** @type {(inputs: Shipping_Fee_DomesticInputs) => LocalizedString} */
const ko_shipping_fee_domestic = en_shipping_fee_domestic;

/**
* | output |
* | --- |
* | "Domestic" |
*
* @param {Shipping_Fee_DomesticInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const shipping_fee_domestic = /** @type {((inputs?: Shipping_Fee_DomesticInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_Fee_DomesticInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shipping_fee_domestic(inputs)
	if (locale === "es") return es_shipping_fee_domestic(inputs)
	if (locale === "fr") return fr_shipping_fee_domestic(inputs)
	if (locale === "de") return de_shipping_fee_domestic(inputs)
	if (locale === "ja") return ja_shipping_fee_domestic(inputs)
	if (locale === "zh") return zh_shipping_fee_domestic(inputs)
	if (locale === "ar") return ar_shipping_fee_domestic(inputs)
	if (locale === "id") return id_shipping_fee_domestic(inputs)
	if (locale === "it") return it_shipping_fee_domestic(inputs)
	if (locale === "ru") return ru_shipping_fee_domestic(inputs)
	if (locale === "pt") return pt_shipping_fee_domestic(inputs)
	return ko_shipping_fee_domestic(inputs)
});